import Vue from 'vue'

export default function createRecalculation(vm) {
  const state = Vue.observable({
    totalFulfillmentCost: 0,
  })

  const buildPayload = packet => {
    const currentPacket = packet
    currentPacket.isLoading = true
    const products = packet.packetContent.map(item => ({
      product_id: item.option.value,
      total_item: item.amount,
      is_product_bonus: item.option.is_product_bonus,
      is_bundling: item.option.is_bundling,
      storage_type: item.option.storage_type,
      bundle_components: item.option.is_bundling ? item.option.variants.map(variant => ({
        product_id: variant.product_id,
        qty: variant.qty,
        is_product_bonus: variant.is_product_bonus,
        storage_type: variant.storage_type,
      })) : [],
    }))

    const packings = packet.packings.map(material => ({
      id: material.id,
      total_layer: Number(material.layer),
    }))

    const body = {
      warehouse_id: vm.warehouse.id,
      total_order: packet.total,
      packings,
      products,
    }

    return body
  }

  /**
   * Recalculates the fulfillment for a given packet.
   * @param packet {Object} - The packet object to recalculate the fulfillment.
   * @param index {Number} - The index of the packet.
   * @returns {Promise<void>} - A promise that resolves when the recalculation is complete.
   */
  const recalculateFulfillment = async (packet, beenMapped = false) => {
    const body = beenMapped ? packet : buildPayload(packet)
    try {
      const response = await vm.$http_new.post('/komship/api/v2/orders/recalculate-fulfillment', body)
      state.totalFulfillmentCost = response.data.data.grand_fulfillment_cost
      return {
        success: true,
        data: response.data.data,
      }
    } catch {
      vm.$toast_error({ message: 'Gagal menyimpan paket. Silakan coba lagi' })
      return {
        success: false,
        message: 'Gagal menyimpan paket. Silakan coba lagi',
      }
    }
  }
  return {
    recalculateFulfillment,
    state,
  }
}
